import { useParams, useNavigate } from 'react-router-dom';
import { Card, Spin } from '@/shared/ui/primitives';
import { useTranslation } from 'react-i18next';
import PageHeader from '@/shared/components/PageHeader';
import CityForm from '../components/CityForm';
import { useCityDetails } from '../hooks/useCityDetails';
import { useUpdateCity } from '../hooks/useCityMutations';
import type { CityFormData } from '@/shared/types';

export default function CityEditPage() {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { data, isLoading: loadingDetails } = useCityDetails(id);
  const mutation = useUpdateCity();

  const handleSubmit = (formData: CityFormData) => {
    mutation.mutate({ id: id!, data: formData }, { onSuccess: () => navigate('/cities') });
  };

  if (loadingDetails) return <Spin size="large" style={{ display: 'flex', justifyContent: 'center', padding: 48 }} />;

  return (
    <div>
      <PageHeader back title={t('cities.edit')} subtitle={data?.nameEn} />
      <Card style={{ marginTop: 16 }}>
        <CityForm initialData={data} onSubmit={handleSubmit} isLoading={mutation.isPending} />
      </Card>
    </div>
  );
}
